import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import type { DefaultRootState } from "react-redux";

interface CreateDatasourceAndSearchQueriesForAiAgentPayload {
  integrationName: string;
  pluginName: string;
}

export const createDatasourceAndSearchQueriesForAiAgent = (
  payload: CreateDatasourceAndSearchQueriesForAiAgentPayload,
) => {
  return {
    type: ReduxActionTypes.CREATE_DATASOURCE_AND_SEARCH_QUERIES_FOR_AI_AGENT_INIT,
    payload,
  };
};

export const createDatasourceAndSearchQueriesForAiAgentSuccess = () => {
  return {
    type: ReduxActionTypes.CREATE_DATASOURCE_AND_SEARCH_QUERIES_FOR_AI_AGENT_SUCCESS,
    payload: {},
  };
};

export const openCarbonModal = (payload: {
  shouldOpen: boolean;
  integrationType?: DefaultRootState["entities"]["aiAgents"]["selectedIntegrationType"];
}) => {
  return {
    type: ReduxActionTypes.OPEN_CARBON_MODAL,
    payload: {
      ...payload,
      integrationType: payload.integrationType ?? "function-calling",
    },
  };
};

export const setInstallingIntegrationName = (payload: {
  integrationName: string | null;
}) => {
  return {
    type: ReduxActionTypes.INSTALLING_INTEGRATION_NAME,
    payload,
  };
};

export const toggleAISupportModal = () => {
  return {
    type: ReduxActionTypes.TOGGLE_AI_SUPPORT_MODAL,
  };
};

export const setCreateAgentModalOpen = (payload: { isOpen: boolean }) => {
  return {
    type: ReduxActionTypes.SET_CREATE_AGENT_MODAL_OPEN,
    payload,
  };
};

export const setNewUserFlowForAgent = (payload: { isEnabled: boolean }) => {
  return {
    type: ReduxActionTypes.SET_NEW_USER_FLOW_FOR_AGENT,
    payload,
  };
};

export const setIsCreatingAgent = (payload: { isCreatingAgent: boolean }) => {
  return {
    type: ReduxActionTypes.SET_IS_CREATING_AGENT,
    payload,
  };
};
